export default {
  init: () => {
    new Swiper ('.prekiu_zenklai_swiper', {
      slidesPerView: 'auto',
      freeMode: true,
    });

    const $bottle_wrapper = $('.bottle_wrapper');

    $bottle_wrapper.hover(function() {
      $bottle_wrapper.removeClass('active');
      $(this).find('.block, .hidden').toggleClass('block').toggleClass('hidden');
      $(this).addClass('active');

      $('.bottle_content').addClass('hidden');
      $(`#${$(this).data('bottle-content')}`).removeClass('hidden');
    });

    // $bottle_wrapper.mouseleave(function() {
    //   setTimeout(() => $('.bottle_content').addClass('hidden'), 1200);
    // });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/prekiu_zenklai_swiper.js